export const selectAuth = {
	fetch: (state) => state.utils.auth.fetch,
	succes: (state) => state.utils.auth.succes,
	authSession: (state) => state.utils.auth.authSession,
};
